const lbaPerDiemGridItem = angular.module('app.lbaPerDiemGridItem', [
]);

lbaPerDiemGridItem.controller('lbaPerDiemGridItemCtrl', require('./lbaPerDiemGridItemCtrl'));
lbaPerDiemGridItem.directive('lbaPerDiemGridItem', require('./lbaPerDiemGridItemDir'));
lbaPerDiemGridItem.service('perDiemService', require('../../services/perDiemService'));

export default lbaPerDiemGridItem;



// WEBPACK FOOTER //
// ./src/components/lbaPerdiemGridItem/index.js